<div class="nv-date-picker-header">
  <span class="month-label">{{ monthLabel }}</span>
  <div class="nav-container">
    <nv-icon-button [name]="'arrow-left-selected'" (clickButton)="previousClicked()" [disabled]="!lastMonthActive"></nv-icon-button>
    <nv-icon-button [name]="'arrow-right-selected'" (clickButton)="nextClicked()" [disabled]="!nextMonthActive"></nv-icon-button>
  </div>
</div>
